import React, { useState, useRef, useEffect } from "react";
import "./vision.css";

const Vision = () => {
  const [isVisible, setIsVisible] = useState(false); // Track visibility state
  const visionRef = useRef(null); // Create a reference for the vision container

  // Intersection Observer to detect when the section is in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true); // Set to true when the section comes into view
        }
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    if (visionRef.current) {
      observer.observe(visionRef.current); // Start observing the vision container
    }

    // Cleanup the observer when the component is unmounted
    return () => {
      if (visionRef.current) {
        observer.unobserve(visionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={visionRef}
      className={`vision-container ${isVisible ? "fade-in" : ""}`}
    >
      <div className="about-title-wrapper">
        <h2 className="about-title">VISION</h2>
      </div>
      <p className="vision-content">
        Sri Takshashila Gurukul is a sanctuary of wisdom, dedicated to those who have the zeal to learn and grow. As a non-profit organization, we focus on the holistic development of such passionate individuals, seeking no personal gain—only the fulfillment of empowering young minds for a brighter future.
      </p>
    </div>
  );
};

export default Vision;
